module.exports = __webpack_public_path__ + "static/media/brazos.08853fe4.svg";